import React from 'react';
import {Button, useColorMode} from '@chakra-ui/react';
import {FiMoon, FiSun} from 'react-icons/fi';

export default function ColorModeToggle() {
  const {colorMode, toggleColorMode} = useColorMode();
  const dark = colorMode === 'dark';
  return <Button type="button" size="sm" variant="outline" color="admin.accent"
    aria-label="Dark mode" aria-pressed={dark} onClick={toggleColorMode}
    title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    leftIcon={dark ? <FiSun aria-hidden="true" /> : <FiMoon aria-hidden="true" />}>
    {dark ? 'Light' : 'Dark'}
  </Button>;
}
